import { request } from './api';

export const getUsers = (options) => request.get('/rei/profile/get-users', options);
